import { FileReader, FileWriter } from "@/platform";
import ModuleId from "./DataStructModuleId";

class ScreenHash {
	public mid = ModuleId.screenHash
	public width: number = 0; // 宽度
	public height: number = 0; // 高度
	public scale: string = ""; // 缩放率（长宽比）

	constructor(_w: number, _h: number, _s: string = "16:9") {
		this.width = _w;
		this.height = _h;
		this.scale = _s;
	}

	ToString() {
		return this.width + "*" + this.height;
	}

	readBin(reader: FileReader): void {
		this.width = reader.readInt()
		this.height = reader.readInt()
		this.scale = reader.readString()
	}

	writeBin(writer: FileWriter): void {
		writer.writeInt(this.width)
		writer.writeInt(this.height)
		writer.writeString(this.scale)
	}
}

export default ScreenHash;
